import { kea } from 'kea'
import PropTypes from 'prop-types'

import { updateHeaderFavouritesCount } from 'lib/actions/props'
import headerProps from 'lib/selectors/header-props'

export default kea({
  path: () => ['scenes', 'header', 'index'],

  actions: () => ({
    toggleSearchBox: true,
    toggleActiveMainMenu: true,
    enableIsMenuHovered: true,
    enableIsProfileHovered: true,
    disableIsMenuHovered: true,
    disableIsProfileHovered: true,
    openModal: true,
    fixer: true,
    setActiveSubMenu: item => ({ item }),
    updateAvatar: avatar => ({ avatar })
  }),

  dimensions: {
    windowWidth: [typeof window !== 'undefined' && window.innerWidth, window => window.innerWidth]
  },

  defaults: {
    profileMenuItems: state => headerProps(state).profileMenuItems,
    isSearchPage: state => !!headerProps(state).isSearchPage,
    isInboxThreadPage: state => !!headerProps(state).isInboxThreadPage
  },

  reducers: ({ actions }) => ({
    isSearchPage: [
      [],
      PropTypes.bool,
      {
        fixer: () => true
      }
    ],
    isInboxThreadPage: [
      true,
      PropTypes.bool,
      {
        fixer: () => true
      }
    ],
    profileMenuItems: [
      [],
      PropTypes.array,
      {
        fixer: () => true
      }
    ],
    isOpenModal: [
      false,
      PropTypes.bool,
      {
        [actions.openModal]: (state, _) => !state
      }
    ],
    isSearchBoxVisible: [
      false,
      PropTypes.bool,
      {
        [actions.toggleSearchBox]: state => !state
      }
    ],
    isProfileHovered: [
      null,
      PropTypes.bool,
      {
        [actions.enableIsProfileHovered]: () => true,
        [actions.disableIsProfileHovered]: () => false
      }
    ],
    isMenuHovered: [
      null,
      PropTypes.bool,
      {
        [actions.enableIsMenuHovered]: () => true,
        [actions.disableIsMenuHovered]: () => false
      }
    ],
    activeMainMenu: [
      null,
      PropTypes.bool,
      {
        [actions.toggleActiveMainMenu]: state => !state,
        [actions.enableIsMenuHovered]: () => false,
        [actions.enableIsProfileHovered]: () => false,
        [actions.toggleSearchBox]: () => false
      }
    ],
    activeSubMenu: [
      null,
      PropTypes.string,
      {
        [actions.setActiveSubMenu]: (_, { item }) => item
      }
    ],
    headerFavouritesCount: [
      null,
      PropTypes.number,
      {
        [updateHeaderFavouritesCount]: (_, { count }) => count
      }
    ],
    auxAvatar: [
      null,
      PropTypes.string,
      {
        [actions.updateAvatar]: (state, { avatar }) => avatar || state
      }
    ]
  }),
  selectors: ({ selectors }) => ({
    profileMenu: [
      () => [selectors.isMenuHovered, selectors.isProfileHovered],
      (isMenuHovered, isProfileHovered) => isMenuHovered || isProfileHovered,
      PropTypes.bool
    ],
    isSmallScreen: [() => [selectors.windowWidth], windowWidth => windowWidth <= 480, PropTypes.bool]
  })
})
